import { lazy, ComponentType } from "react";

const RELOAD_KEY = "chunk-reload-ts";

export function lazyWithRetry<T extends ComponentType<any>>(
  factory: () => Promise<{ default: T }>
) {
  return lazy(async () => {
    try {
      const mod = await factory();
      // Success — clear the reload flag so future deployments can retry
      sessionStorage.removeItem(RELOAD_KEY);
      return mod;
    } catch (error) {
      const lastReload = sessionStorage.getItem(RELOAD_KEY);
      const now = Date.now();
      // Only skip reload if we already reloaded within the last 10 seconds
      if (lastReload && now - Number(lastReload) < 10_000) {
        throw error;
      }
      sessionStorage.setItem(RELOAD_KEY, String(now));
      window.location.reload();
      return new Promise(() => {});
    }
  });
}
